<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { useStoreGetters } from 'dashboard/composables/store';

import AuditTrailSection from 'next/wgpt/AuditTrail/AuditTrailSection.vue';

const route = useRoute();
const { t } = useI18n();
const getters = useStoreGetters();

const taskId = computed(() => Number(route.params.taskId));
const task = computed(() => getters['wgptTasks/getTask'].value(taskId.value));

const auditTrailFilters = computed(() => {
  const filters = [
    {
      attributeKey: 'model',
      filterOperator: 'equal_to',
      values: {
        id: 'WgptTask',
        name: 'WgptTask',
      },
      queryOperator: 'and',
      attributeModel: 'standard',
    },
    {
      attributeKey: 'id',
      filterOperator: 'equal_to',
      values: taskId.value,
      queryOperator: 'or',
      attributeModel: 'standard',
    },
  ];

  if (task.value?.wgpt_automation_id) {
    filters.push(
      {
        attributeKey: 'model',
        filterOperator: 'equal_to',
        values: {
          id: 'WgptAutomation',
          name: 'WgptAutomation',
        },
        queryOperator: 'and',
        attributeModel: 'standard',
      },
      {
        attributeKey: 'id',
        filterOperator: 'equal_to',
        values: task.value.wgpt_automation_id,
        attributeModel: 'standard',
      }
    );
  }

  return filters;
});
</script>

<template>
  <AuditTrailSection
    :title="t('WGPT_TASKS.EDITOR.SETTINGS.AUDIT_TRAIL.TITLE')"
    :description="t('WGPT_TASKS.EDITOR.SETTINGS.AUDIT_TRAIL.DESCRIPTION')"
    :filters="auditTrailFilters"
  />
</template>
